
const ENV = 'uat';
// const ENV = 'prod';

const API_CONFIG = {
    auto: {
        uat: 'https://autouatapi.acrossassist.in/api/Auto/',
        prod: 'https://autoapi.acrossassist.com/api/Auto/',
    },
    financeVendor: {
        uat: 'https://tmagadgetapi.acrossassist.in/api/FinanceVendor/',
        prod: 'https://gadgetapi.acrossassist.com/api/FinanceVendor/',
    },
    techfinance: {
        uat: 'https://financeuatapi.acrossassist.in/api/Auto',
        prod: 'https://financeapi.acrossassist.com/api/Auto',
    },
};

export const baseURLAuto = API_CONFIG.auto[ENV];
export const baseURLFinanceVendor = API_CONFIG.financeVendor[ENV];
export const baseURLTechFinance = API_CONFIG.techfinance[ENV];

const config = {
    baseURLAuto,
    baseURLFinanceVendor,
    baseURLTechFinance
};

export default config;
